// extracted by mini-css-extract-plugin
module.exports = {"spacer":"j_x","willHide":"j_y","wrapper":"j_h","hidden":"j_z","navbar":"j_p","logoLink":"j_t","logo":"j_v","navigation":"j_w"};